'use client';

import type { VisitorCurationItem } from '@musinsa/services-curator';
import { TitleSection } from '../../common/components/TitleSection';
import { GoodItems } from './GoodItems';
import { VisitorSnapItems } from './VisitorSnapItems';

interface Props {
  snsTitle: string;
  item: VisitorCurationItem;
  pageCache: Map<string, number>;
  setPageCache: React.Dispatch<React.SetStateAction<Map<string, number>>>;
  curationIndex: number;
}

export const CurationItem = ({ snsTitle, item, pageCache, setPageCache, curationIndex }: Props) => (
  <div className="flex flex-col">
    <TitleSection item={item} />
    {item.type === 'SNAP2' ? (
      <VisitorSnapItems
        snsTitle={snsTitle}
        curationId={item.curationId}
        items={item.snapItems ?? []}
      />
    ) : (
      <GoodItems
        snsTitle={snsTitle}
        title={item.title}
        curationId={item.curationId}
        items={item.goodsItems}
        pageCache={pageCache}
        setPageCache={setPageCache}
        curationIndex={curationIndex}
      />
    )}
  </div>
);
